import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OrderInterface } from 'src/interfaces/order'

type State = {
  loading: boolean
  entity: OrderInterface | null
}

const initialState: State = {
  loading: false,
  entity: null,
}

const { actions, reducer } = createSlice({
  name: 'detail_paid_order',
  initialState,
  reducers: {
    updateEntity: (state, action: PayloadAction<OrderInterface>) => {
      state.entity = action.payload
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export { reducer }
export default actions
